import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from "@material-ui/core";
import { arrowRight } from "assets/icons/importIcon";
import useStyles from './styles';
import AppHelper from 'helpers/AppHelper';
import { createSection } from 'actions/brik';
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { CircularProgress } from '@material-ui/core';
import { TYPE_LENGTH } from 'utils';
import { iconSectionContent, iconSectionMeal, iconSectionWorkout } from 'assets/icons'

const ChooseSectionType = (props: any) => {
  const classes = useStyles();
  const { typeSection, setTypeSection, backStep, typeName } = props;

  const onHandleCloseModal = () => {
    AppHelper.hideGlobalModal();
  };

  const renderTypeNameBrik = () => {
    switch (typeName) {
      case 0:
        return 'lesson plan';
      case 1: 
        return 'program';
      case 2:
        return 'challenge';
    }
  }

  const { loading } = useSelector((state: any) => state.brik);
  const { data, length } = useSelector((state: any) => state.brik);

  const dispatch = useDispatch();
  const history = useHistory();
  
  const onFinishClick = async () => {
    if (parseInt(data.length) === TYPE_LENGTH.NO_DURATION) {
      if (typeSection !== '') {
        await dispatch(createSection(data.id, { type_section: typeSection, order: 1 }));
      } 
    } else if (parseInt(data.length) === TYPE_LENGTH.DAY || parseInt(data.length) === TYPE_LENGTH.WEEK) {
      if (typeSection !== '' && length) {
        await dispatch(createSection(data.id, { type_section: typeSection, order: 1, length_id: length.id }));
      } 
    }
    
    AppHelper.hideGlobalModal();
    history.push(`/brik/detail/${data.id}`, { length: parseInt(data.length) });
  };

  return (
    <>
      <div className={classes.bodyModalList}>
        <div className={classes.iconCloseIcon} onClick={onHandleCloseModal}>
          <CloseIcon />
        </div>
        <div className={classes.contentTitle}>
          What type of sections do you need for this {renderTypeNameBrik()}?
        </div>
        <div className={classes.subContentTitle}>
          Select a section you’d like to start with, you can always add these as you go.
        </div>
        <div className={classes.listType}>
          <div
            className={classes.itemType}
            onClick={() => setTypeSection(0)}
            style={{ border: typeSection === 0 ? '1px solid #0C85F4' : '' }}
          >
            <img src={iconSectionContent} alt='' />
            <p className={classes.typeTitle}>Content</p>
            <p className={classes.typeDes}>
              Create custom text, images, audio, or video content.
            </p>
          </div>

          <div
            className={classes.itemType}
            onClick={() => setTypeSection(1)}
            style={{ border: typeSection === 1 ? '1px solid #0C85F4' : '' }}
          >
            <img src={iconSectionMeal} alt='' />
            <p className={classes.typeTitle}>Meal Plan</p>
            <p className={classes.typeDes} style={{ marginBottom: 30 }}>
              Create recipes and a full meal plan.
            </p>
          </div>

          <div
            className={classes.itemType}
            onClick={() => setTypeSection(2)}
            style={{ border: typeSection === 2 ? '1px solid #0C85F4' : '' }}
          >
            <img src={iconSectionWorkout} alt='' />
            <p className={classes.typeTitle}>Workout</p>
            <p className={classes.typeDes} style={{ marginBottom: 30 }}>
              Create a full workout or recovery plan.
            </p>
          </div>
        </div>
      </div>
      <div className={classes.footerModal}>
        {/* <div className={classes.buttonBack}>
          <Button variant="contained" onClick={backStep}>
            Back
          </Button>
        </div> */}
        <div className={classes.btnAddRecipeBody}>
          <Button variant="contained" onClick={onFinishClick} disabled={loading}>
            <span>Next</span>
            {loading ? (
              <span className={classes.iconLoading}>
                <CircularProgress size={16} />
              </span>
            ) :
              <img src={arrowRight} alt="" />
            }
          </Button>
        </div>
      </div>
    </>
  );
};

export default ChooseSectionType;
